export default __webpack_public_path__ + "static/15-min-de33ca737dda735157f5be3f868f98f8.png";